import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgEditIconSecondary from './svgs/EditIconSecondary.js';
import SvgEditIcon from './svgs/EditIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var editIcon = (props => useIcon(SvgEditIcon, SvgEditIconSecondary, props));

export { editIcon as default };
